<template>
  <div class="flex">
    <div class="flex justify-center bg-gray-100 p-2 w-full h-screen">

      <div>
        <div class="justify-center">
          <h1 class="text-2xl font-semibold mb-6">很Low的合约部署生成器</h1>
          <h3 class="text-sm mb-6">可支持ERC20协议的各种主网，童叟无欺，非常建议您先在测试网上验证通过后再主网部署合约</h3>
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">代币名称</label>
          <input v-model="tokenName" placeholder="合约名称"
            class="w-full p-2 border rounded focus:outline-none focus:ring focus:border-blue-300" />
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">简称</label>
          <input v-model="tokenSymbol" placeholder="代币简称"
            class="w-full p-2 border rounded focus:outline-none focus:ring focus:border-blue-300" />
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">发行总量</label>
          <input v-model="totalSupply" placeholder="发行数量" type="number"
            class="w-full p-2 border rounded focus:outline-none focus:ring focus:border-blue-300" />
        </div>
        <button @click="pay"
          class="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 focus:outline-none focus:ring focus:border-blue-300">
          打赏些GAS就可以部署
        </button>

        <div class="p-2 bg-white rounded shadow-md">
        <div v-if="currentStep === 'paying'">
          <div class="mb-4">
            <p class="text-lg font-semibold">正在向平台支付gas费用...</p>
          </div>
          <div v-if="isPayed"> 
            <button @click="deployContract" class="bg-blue-500 text-white px-4 py-2 rounded">开始部署</button>
          </div>
        </div>

        <div v-else-if="currentStep === 'deploying'">
          <div class="mb-4">
            <p class="text-lg font-semibold">正在部署...</p>
          </div>
          <div class="animate-spin rounded-full h-6 w-6 border-t-2 border-blue-500 border-opacity-75"></div>
        </div>

        <div v-else-if="currentStep === 'deployed'">
          <div class="mb-4">
            <p class="text-lg font-semibold">部署完成！</p>
          </div>
          <p class="text-gray-600">请记好合约地址：{{ currentStatus }}</p>
        </div>

        <div v-else-if="currentStep == 'failed'">
          <div class="mb-4">
            <p class="text-lg text-red-500 font-semibold">{{ currentStatus }}</p>
          </div>
        </div>
      </div>
      </div>


      

    </div>
  </div>
</template>
  
<script>
import Web3 from "web3";
import { mapState } from 'vuex';

export default {
  data() {
    return {
      tokenName: "",
      tokenSymbol: "",
      totalSupply: 0,
      deploying: false,
      currentStep: "",
      currentStatus: "",
      networkName: "",
      isPayed:false,
      //contractBytecode: "0x...", // Replace with your contract bytecode
      contractBytecode: "0x60a0604052601260035561dead6080523480156200001c57600080fd5b506040516200173b3803806200173b8339810160408190526200003f9162000422565b600080546001600160a01b031916339081178255604051909182917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908290a3508251156200008d57600080fd5b8051156200009a57600080fd5b600032905084600081518110620000b557620000b5620005ce565b602002602001015160019080519060200190620000d4929190620001af565b5084600181518110620000eb57620000eb620005ce565b6020026020010151600290805190602001906200010a929190620001af565b5082600081518110620001215762000121620005ce565b602002602001015160038190555082600181518110620001455762000145620005ce565b60209081029190910181015160078190556001600160a01b038316600081815260048452604080822084905551928352909290917fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef910160405180910390a3505050505062000621565b828054620001bd90620005e4565b90600052602060002090601f016020900481019282620001e157600085556200022c565b82601f10620001fc57805160ff19168380011785556200022c565b828001600101855582156200022c579182015b828111156200022c5782518255916020019190600101906200020f565b506200023a9291506200023e565b5090565b5b808211156200023a57600081556001016200023f565b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f191681016001600160401b038111828210171562000296576200029662000255565b604052919050565b60006001600160401b03821115620002ba57620002ba62000255565b5060051b60200190565b600082601f830112620002d657600080fd5b81516020620002ef620002e9836200029e565b6200026b565b82815260059290921b840181019181810190868411156200030f57600080fd5b8286015b84811015620003435780516001600160a01b0381168114620003355760008081fd5b835291830191830162000313565b509695505050505050565b600082601f8301126200036057600080fd5b8151602062000373620002e9836200029e565b82815260059290921b840181019181810190868411156200039357600080fd5b8286015b8481101562000343578051835291830191830162000397565b600082601f830112620003c257600080fd5b81516020620003d5620002e9836200029e565b82815260059290921b84018101918181019086841115620003f557600080fd5b8286015b84811015620003435780518015158114620004145760008081fd5b8352918301918301620003f9565b600080600080608085870312156200043957600080fd5b84516001600160401b03808211156200045157600080fd5b818701915087601f8301126200046657600080fd5b8151602062000479620002e9836200029e565b82815260059290921b8401810191818101908b8411156200049957600080fd5b8286015b848110156200054e57805186811115620004b657600080fd5b8701603f81018e13620004c857600080fd5b8481015187811115620004df57620004df62000255565b620004f3601f8201601f191687016200026b565b8181528f60408385010111156200050a5760008081fd5b60005b828110156200052b578381016040015182820189015287016200050d565b828111156200053d5760008884840101525b50855250509183019183016200049d565b50918a01519198509093505050808211156200056957600080fd5b6200057788838901620002c4565b945060408701519150808211156200058e57600080fd5b6200059c888389016200034e565b93506060870151915080821115620005b357600080fd5b50620005c287828801620003b0565b91505092959194509250565b634e487b7160e01b600052603260045260246000fd5b600181811c90821680620005f957607f821691505b602082108114156200061b57634e487b7160e01b600052602260045260246000fd5b50919050565b6080516110f7620006446000396000818161020801526106b401526110f76000f3fe60806040526004361061012e5760003560e01c806370a08231116100ab578063a457c2d71161006f578063a457c2d714610363578063a9059cbb14610383578063dd62ed3e146103a3578063e43252d7146103e9578063e9d1c5981461028c578063f2fde38b1461040957600080fd5b806370a08231146102c5578063715018a6146102fb5780638da5cb5b146103105780639281aa0b1461032e57806395d89b411461034e57600080fd5b806327c8f835116100f257806327c8f835146101f65780632b112e4914610242578063313ce56714610257578063395093511461026c5780633af32abf1461028c57600080fd5b806306fdde031461013a578063095ea7b3146101655780630d3c69b41461019557806318160ddd146101b757806323b872dd146101d657600080fd5b3661013557005b600080fd5b34801561014657600080fd5b5061014f610429565b60405161015c9190610e45565b60405180910390f35b34801561017157600080fd5b50610185610180366004610eb6565b6104bb565b604051901515815260200161015c565b3480156101a157600080fd5b506101b56101b0366004610ee0565b6104d1565b005b3480156101c357600080fd5b506007545b60405190815260200161015c565b3480156101e257600080fd5b506101856101f1366004610ef9565b610648565b34801561020257600080fd5b5061022a7f000000000000000000000000000000000000000000000000000000000000000081565b6040516001600160a01b03909116815260200161015c565b34801561024e57600080fd5b506101c86106b2565b34801561026357600080fd5b506003546101c8565b34801561027857600080fd5b50610185610287366004610eb6565b6106fc565b34801561029857600080fd5b506101856102a7366004610f35565b6001600160a01b031660009081526006602052604090205460ff1690565b3480156102d157600080fd5b506101c86102e0366004610f35565b6001600160a01b031660009081526004602052604090205490565b34801561030757600080fd5b506101b5610732565b34801561031c57600080fd5b506000546001600160a01b031661022a565b34801561033a57600080fd5b506101b5610349366004610f50565b6107ac565b34801561035a57600080fd5b5061014f610835565b34801561036f57600080fd5b5061018561037e366004610eb6565b610844565b34801561038f57600080fd5b5061018561039e366004610eb6565b610893565b3480156103af57600080fd5b506101c86103be366004610f8c565b6001600160a01b03918216600090815260056020908152604080832093909416825291909152205490565b3480156103f557600080fd5b506101b5610404366004610f35565b6108a0565b34801561041557600080fd5b506101b5610424366004610f35565b610994565b60606001805461043890610fbf565b80601f016020809104026020016040519081016040528092919081815260200182805461046490610fbf565b80156104b15780601f10610486576101008083540402835291602001916104b1565b820191906000526020600020905b81548152906001019060200180831161049457829003601f168201915b5050505050905090565b60006104c8338484610a7e565b50600192915050565b3360009081526006602052604090205460ff166105415760405162461bcd60e51b815260206004820152602360248201527f466174546f6b656e3a2063616c6c6572206973206e6f742077686974656c69736044820152621d195960ea1b60648201526084015b60405180910390fd5b336105995760405162461bcd60e51b815260206004820152602260248201527f466174546f6b656e3a206d696e7420746f20746865207a65726f206164647265604482015261737360f01b6064820152608401610538565b6007546105a69082610ba2565b600755336000908152600460205260409020546105c39082610ba2565b336000818152600460209081526040918290209390935551838152909182917fab8530f87dc9b59234c4623bf917212bb2536d647574c8e7e5da92c2ede0c9f8910160405180910390a360405181815233906000907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9060200160405180910390a350565b6000610655848484610c08565b506106a884336106a385604051806060016040528060288152602001611075602891396001600160a01b038a1660009081526005602090815260408083203384529091529020549190610ce3565b610a7e565b5060019392505050565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166000908152600460205260408120546007546106f791610d1d565b905090565b3360008181526005602090815260408083206001600160a01b038716845290915281205490916104c89185906106a39086610ba2565b6000546001600160a01b0316331461075c5760405162461bcd60e51b815260040161053890610ffa565b6000805460405161dead926001600160a01b03909216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a3600080546001600160a01b03191661dead179055565b6000546001600160a01b031633146107d65760405162461bcd60e51b815260040161053890610ffa565b6001600160a01b038216600081815260066020908152604091829020805460ff191685151590811790915591519182527fa54714518c5d275fdcd3d2a461e4858e4e8cb04fb93cd0bca9d6d34115f26440910160405180910390a25050565b60606002805461043890610fbf565b60006104c833846106a38560405180606001604052806025815260200161109d602591393360009081526005602090815260408083206001600160a01b038d1684529091529020549190610ce3565b60006106a8338484610c08565b6000546001600160a01b031633146108ca5760405162461bcd60e51b815260040161053890610ffa565b6001600160a01b0381166109375760405162461bcd60e51b815260206004820152602e60248201527f466174546f6b656e3a2063616e6e6f7420616464207a65726f2061646472657360448201526d1cc81d1bc81dda1a5d195b1a5cdd60921b6064820152608401610538565b6001600160a01b038116600081815260066020908152604091829020805460ff1916600190811790915591519182527fa54714518c5d275fdcd3d2a461e4858e4e8cb04fb93cd0bca9d6d34115f26440910160405180910390a250565b6000546001600160a01b031633146109be5760405162461bcd60e51b815260040161053890610ffa565b6001600160a01b038116610a235760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b6064820152608401610538565b600080546040516001600160a01b03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a3600080546001600160a01b0319166001600160a01b0392909216919091179055565b6001600160a01b038316610ae05760405162461bcd60e51b8152602060048201526024808201527f45524332303a20617070726f76652066726f6d20746865207a65726f206164646044820152637265737360e01b6064820152608401610538565b6001600160a01b038216610b415760405162461bcd60e51b815260206004820152602260248201527f45524332303a20617070726f766520746f20746865207a65726f206164647265604482015261737360f01b6064820152608401610538565b6001600160a01b0383811660008181526005602090815260408083209487168084529482529182902085905590518481527f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925910160405180910390a3505050565b600080610baf8385611045565b905083811015610c015760405162461bcd60e51b815260206004820152601b60248201527f536166654d6174683a206164646974696f6e206f766572666c6f7700000000006044820152606401610538565b9392505050565b60006001600160a01b038416610c6e5760405162461bcd60e51b815260206004820152602560248201527f45524332303a207472616e736665722066726f6d20746865207a65726f206164604482015264647265737360d81b6064820152608401610538565b6001600160a01b038316610cd05760405162461bcd60e51b815260206004820152602360248201527f45524332303a207472616e7366657220746f20746865207a65726f206164647260448201526265737360e81b6064820152608401610538565b610cdb848484610d5f565b949350505050565b60008184841115610d075760405162461bcd60e51b81526004016105389190610e45565b506000610d14848661105d565b95945050505050565b6000610c0183836040518060400160405280601e81526020017f536166654d6174683a207375627472616374696f6e206f766572666c6f770000815250610ce3565b6040805180820182526014815273496e73756666696369656e742042616c616e636560601b6020808301919091526001600160a01b0386166000908152600490915291822054610db0918490610ce3565b6001600160a01b038086166000908152600460205260408082209390935590851681522054610ddf9083610ba2565b6001600160a01b0380851660008181526004602052604090819020939093559151908616907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef90610e339086815260200190565b60405180910390a35060019392505050565b600060208083528351808285015260005b81811015610e7257858101830151858201604001528201610e56565b81811115610e84576000604083870101525b50601f01601f1916929092016040019392505050565b80356001600160a01b0381168114610eb157600080fd5b919050565b60008060408385031215610ec957600080fd5b610ed283610e9a565b946020939093013593505050565b600060208284031215610ef257600080fd5b5035919050565b600080600060608486031215610f0e57600080fd5b610f1784610e9a565b9250610f2560208501610e9a565b9150604084013590509250925092565b600060208284031215610f4757600080fd5b610c0182610e9a565b60008060408385031215610f6357600080fd5b610f6c83610e9a565b915060208301358015158114610f8157600080fd5b809150509250929050565b60008060408385031215610f9f57600080fd5b610fa883610e9a565b9150610fb660208401610e9a565b90509250929050565b600181811c90821680610fd357607f821691505b60208210811415610ff457634e487b7160e01b600052602260045260246000fd5b50919050565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b634e487b7160e01b600052601160045260246000fd5b600082198211156110585761105861102f565b500190565b60008282101561106f5761106f61102f565b50039056fe45524332303a207472616e7366657220616d6f756e74206578636565647320616c6c6f77616e636545524332303a2064656372656173656420616c6c6f77616e63652062656c6f77207a65726fa26469706673582212208a4b3098284e40349313acffa1133f00533293d40c375531f3d2b4e57cd9931d64736f6c634300080b0033",

      contractABI: [
        {
          "inputs": [
            {
              "internalType": "string[]",
              "name": "stringParams",
              "type": "string[]"
            },
            {
              "internalType": "address[]",
              "name": "addressParams",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "numberParams",
              "type": "uint256[]"
            },
            {
              "internalType": "bool[]",
              "name": "boolParams",
              "type": "bool[]"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "spender",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "value",
              "type": "uint256"
            }
          ],
          "name": "Approval",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "minter",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "recipient",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            }
          ],
          "name": "Mint",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "previousOwner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "OwnershipTransferred",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "value",
              "type": "uint256"
            }
          ],
          "name": "Transfer",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "account",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "bool",
              "name": "isWhite",
              "type": "bool"
            }
          ],
          "name": "Whitelisted",
          "type": "event"
        },
        {
          "inputs": [],
          "name": "deadAddress",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "constant": true
        },
        {
          "inputs": [],
          "name": "owner",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "constant": true
        },
        {
          "inputs": [],
          "name": "renounceOwnership",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "transferOwnership",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "stateMutability": "payable",
          "type": "receive",
          "payable": true
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            },
            {
              "internalType": "bool",
              "name": "isWhite",
              "type": "bool"
            }
          ],
          "name": "setWhitelisted",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "isWhitelisted",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "constant": true
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            }
          ],
          "name": "selfMint",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "isEligibleForAirdrop",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "constant": true
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "addToWhitelist",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "name",
          "outputs": [
            {
              "internalType": "string",
              "name": "",
              "type": "string"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "constant": true
        },
        {
          "inputs": [],
          "name": "symbol",
          "outputs": [
            {
              "internalType": "string",
              "name": "",
              "type": "string"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "constant": true
        },
        {
          "inputs": [],
          "name": "decimals",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "constant": true
        },
        {
          "inputs": [],
          "name": "totalSupply",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "constant": true
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "balanceOf",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "constant": true
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "spender",
              "type": "address"
            }
          ],
          "name": "allowance",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "constant": true
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "spender",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "addedValue",
              "type": "uint256"
            }
          ],
          "name": "increaseAllowance",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "spender",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "subtractedValue",
              "type": "uint256"
            }
          ],
          "name": "decreaseAllowance",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "spender",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            }
          ],
          "name": "approve",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getCirculatingSupply",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "constant": true
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "recipient",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            }
          ],
          "name": "transfer",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "sender",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "recipient",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            }
          ],
          "name": "transferFrom",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        }] // Replace with your contract ABI
    };
  },

  computed: {
    ...mapState(['userAddress', "connected"]),
  },

  methods: {

    async pay() {
      // 检查是否安装了 MetaMask
      if (typeof window.ethereum === 'undefined') {
        alert('请安装 MetaMask 钱包');
        return;
      }

      //this.getGasPrice

      // 请求用户授权
      // const web3 = new Web3(window.ethereum);

      // 获取用户账户地址
      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
      const fromAddress = accounts[0];

      // 支付的接收地址
      const toAddress = '0xd192CCd46050612C4EE2620AFF85aAC1042f497c'; // 替换成接收地址

      // 支付金额（以 wei 为单位，0.01 ETH 对应的 wei 数量）

      // 发起支付
      try {
        //  const gasPrice = await web3.eth.getGasPrice();
        // const gas = 21000; // Gas limit for a standard ETH transfer
        // const value = web3.utils.toWei('0.001', 'ether'); // Amount to send in wei (0.001 ETH)

        //const gasPrice = await web3.eth.getGasPrice();
        //const gas = 21000; // Gas limit for a standard ETH transfer

        // 估算 Gas 使用量
        // const estimatedGas = await window.ethereum.request({
        //   method: 'eth_estimateGas',
        //   params: [
        //     {
        //       from: fromAddress,
        //       to: toAddress,
        //       value: web3.utils.toWei('0.01', 'ether'),
        //     },
        //   ],
        // });
        // // 设置 Gas 限制为估算值加上一定的余量
        // const gasLimit = estimatedGas + 10000; // 加上一定的余量，以确保交易执行
        // const gasPrice = this.getGasPrice() 

        this.currentStep="paying";
        console.log("交易" + " from:" + fromAddress + " --> to:" + toAddress);

        const txHash = await window.ethereum.request({
          method: 'eth_sendTransaction',
          params: [
            {
              from: fromAddress,
              to: toAddress,
              value: Web3.utils.numberToHex(Web3.utils.toWei('0.1', 'ether')), // 要发送的金额，以 wei 为单位
              gasPrice: Web3.utils.numberToHex('5000000000'), // Gas price in gwei
              gas: Web3.utils.numberToHex('21000')        // Gas limit for standard ETH transfer
            },
          ],
        });
        this.isPayed=true;
        console.log('交易发送成功:' + txHash);
      } catch (error) {
        console.error('交易发送失败:', error);
      }
    },

    async deployContract() {

      if (this.connected) {

        if (this.tokenName && this.tokenSymbol && this.totalSupply) {

          var supply = this.totalSupply + "000000000000000000";

          this.deploying = true;
          this.currentStep = "initializing";
          this.currentStatus = "Creating contract Initializing...";

          const web3 = new Web3(window.ethereum);
          const contract = new web3.eth.Contract(this.contractABI);

          this.currentStep = "deploying";
          this.currentStatus = "Deploying contract...";

          const stringParams = [this.tokenName, this.tokenSymbol]; // Name and Symbol
          const addressParams = []; // No address parameters for this contract
          const numberParams = [18, supply]; // Decimals and Total Supply (in wei)
          const boolParams = []; // No bool parameters for this contract

          try {
            // // 获取网络编号
            // web3.eth.net.getId((error, networkId) => {
            //   if (error) {
            //     console.error('获取网络编号失败：', error);
            //   } else {
            //     console.log('连接的网络编号：', networkId);
            //   }
            // });

            // 检查用户是否已连接到钱包
            // if (web3) {
            //   // 请求用户授权访问账户
            //   window.ethereum.enable()
            //     .then(accounts => {
            //       // 获取用户的钱包地址
            //       userAddress = accounts[0];
            //       console.log('用户的钱包地址：', userAddress);
            //     })
            //     .catch(error => {
            //       this.currentStep = "failed";
            //       this.currentStatus = '授权失败：'+ error

            //       console.error('授权失败：', error);
            //     });
            // } else {
            //     this.currentStep = "failed";
            //     this.currentStatus = "请安装MetaMask或其他以太坊钱包插件";

            //     console.log('请安装MetaMask或其他以太坊钱包插件');
            // }

            // //
            // if(userAddress==""){
            //     this.currentStep = "failed";
            //     this.currentStatus = "请先连接钱包网络";
            // }

            const accounts = await web3.eth.getAccounts();
            const deployedContract = await contract.deploy({
              data: this.contractBytecode,
              arguments: [stringParams,
                addressParams,
                numberParams,
                boolParams]
            }).send({
              from: accounts[0],
              gas: 2000000, // 设置适当的 gas 限制
              gasPrice: '5000000000' // 设置适当的 gas 价格
            }).on('transactionHash', hash => {
              console.log('交易已发送，交易哈希：', hash);
            }).on('receipt', receipt => {
              console.log('交易已确认，合约地址：', receipt.contractAddress);
            }).on('error', error => {
              console.error('交易错误：', error);
            })

            this.currentStep = "deployed";
            this.currentStatus = "Contract deployed at " + deployedContract.options.address;
          } catch (error) {
            console.log('error :' + error);
            this.currentStep = "failed";
            this.currentStatus = error.message;
          }

          this.deploying = false;
        } else {
          alert("Please enter token name and total supply.");
        }
      } else {
        this.currentStep = "failed";
        this.currentStatus = "请先链接钱包网络";
      }
    },


    async getGasPrice() {
      console.log("invoke getGasPrice")
      if (window.ethereum && window.ethereum.request) {
        const web3 = new Web3(window.ethereum);

        const gasPrice = await web3.eth.getGasPrice();
        console.log(`Gas Price: ${gasPrice}`);
        return gasPrice

      } else {
        console.error('window.ethereum is not available');
      }
    }

  }
};
</script>
  